module.exports = __webpack_public_path__ + "img/logo.c194314a.png";